<template>
    <v-container fluid>
        <v-card>
            <v-form ref="billingItemFormIA" v-model="isValid">
                <v-card-text>
                    <v-container class="pb-0" fluid>
                        <v-row v-if="billingItem.id > 0" class="pb-0">
                            <v-col cols="12"></v-col>

                            <v-col cols="12">
                                <v-textarea
                                    :disabled="isLoading"
                                    label="Diagnosis"
                                    outlined
                                    auto-grow
                                    v-model="billingItem.arDiagnosis"
                                ></v-textarea>
                            </v-col>

                            <v-col cols="12">
                                <v-textarea
                                    :disabled="isLoading"
                                    label="Pre-assessment"
                                    outlined
                                    auto-grow
                                    v-model="billingItem.arPreAssessment"
                                ></v-textarea>
                            </v-col>

                            <v-col cols="12">
                                <h3>
                                    Files
                                    <v-btn
                                        :disabled="isLoading"
                                        @click="newAccountFileA"
                                        class="text-none ml-2"
                                        color="secondary darken-1"
                                        fab
                                        x-small
                                    >
                                        <v-icon>mdi-plus</v-icon>
                                    </v-btn>
                                </h3>
                                <v-card
                                    :key="billingItemFile.id"
                                    @click="
                                        loadAccountFileFormA(billingItemFile)
                                    "
                                    class="mt-5"
                                    no-gutters
                                    v-for="billingItemFile in billingItemFilesA"
                                >
                                    <v-card-text class="py-0">
                                        <v-row>
                                            <v-col cols="8">
                                                {{
                                                    accountFileTypes.find(
                                                        (x) =>
                                                            x.key ==
                                                            billingItemFile.accountFileType
                                                    )
                                                        ? accountFileTypes.find(
                                                              (x) =>
                                                                  x.key ==
                                                                  billingItemFile.accountFileType
                                                          ).value
                                                        : ""
                                                }}
                                            </v-col>

                                            <v-col
                                                align-self="center"
                                                class="text-center"
                                                cols="4"
                                            >
                                                <v-btn
                                                    @click.stop="
                                                        $store.dispatch(
                                                            'files/get',
                                                            {
                                                                fileId:
                                                                    billingItemFile.fileId,
                                                                namePrefix:
                                                                    billingItemFile.billingItemId.toString() +
                                                                    '_' +
                                                                    accountFileTypes
                                                                        .find(
                                                                            (
                                                                                x
                                                                            ) =>
                                                                                x.key ==
                                                                                billingItemFile.accountFileType
                                                                        )
                                                                        .value.split(
                                                                            ' '
                                                                        )
                                                                        .join(
                                                                            '_'
                                                                        ),
                                                            }
                                                        )
                                                    "
                                                    fab
                                                >
                                                    <h3>
                                                        <v-icon
                                                            color="light-blue"
                                                            >mdi-download</v-icon
                                                        >
                                                    </h3>
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                            </v-col>

                            <v-col cols="12">
                                <h4>
                                    Was the patient treated in theatre by you on this billing date?
                                </h4>
                                <v-switch
                                    :disabled="isLoading"
                                    :label="
                                        billingItem.arDischarged ? 'Yes' : 'No'
                                    "
                                    v-model="billingItem.arDischarged"
                                ></v-switch>
                            </v-col>

                            <v-col cols="12">
                                <h4>Anaesthesia Report</h4>
                                <v-card
                                    flat
                                    outlined
                                    v-show="billingItem.arDischarged"
                                >
                                    <v-card-text>
                                        <v-row class="pa-0 ma-0">
                                            <v-col cols="12">
                                                <v-text-field
                                                    outlined
                                                    :disabled="isLoading"
                                                    :rules="[]"
                                                    label="Procedure"
                                                    v-model="
                                                        billingItem.arProcedure
                                                    "
                                                ></v-text-field
                                            ></v-col>

                                            <v-col cols="12">
                                                <v-text-field
                                                    outlined
                                                    :disabled="isLoading"
                                                    :rules="[]"
                                                    label="Surgeon"
                                                    v-model="
                                                        billingItem.arSurgeon
                                                    "
                                                ></v-text-field
                                            ></v-col>

                                            <v-col cols="12">
                                                <v-text-field
                                                    outlined
                                                    :disabled="isLoading"
                                                    :rules="[lengthRule(100)]"
                                                    label="Theater time in"
                                                    v-model="
                                                        billingItem.arTheaterTimeIn
                                                    "
                                                ></v-text-field
                                            ></v-col>

                                            <v-col cols="12">
                                                <v-text-field
                                                    outlined
                                                    :disabled="isLoading"
                                                    :rules="[lengthRule(100)]"
                                                    label="Theater time out"
                                                    v-model="
                                                        billingItem.arTheaterTimeOut
                                                    "
                                                ></v-text-field
                                            ></v-col>

                                            <v-col cols="12">
                                                <v-text-field
                                                    outlined
                                                    :disabled="isLoading"
                                                    :rules="[]"
                                                    label="Spinal/General"
                                                    v-model="
                                                        billingItem.arSpinalGeneral
                                                    "
                                                ></v-text-field
                                            ></v-col>

                                            <v-col cols="12">
                                                <v-textarea
                                                    :disabled="isLoading"
                                                    label="Drugs used"
                                                    outlined
                                                    auto-grow
                                                    v-model="
                                                        billingItem.arDrugsUsed
                                                    "
                                                ></v-textarea>
                                            </v-col>

                                            <v-col cols="12">
                                                <v-text-field
                                                    outlined
                                                    :disabled="isLoading"
                                                    :rules="[]"
                                                    label="Intubation"
                                                    v-model="
                                                        billingItem.arIntubation
                                                    "
                                                ></v-text-field
                                            ></v-col>

                                            <v-col cols="12">
                                                <v-text-field
                                                    outlined
                                                    :disabled="isLoading"
                                                    :rules="[]"
                                                    label="Blood loss"
                                                    v-model="
                                                        billingItem.arBloodLoss
                                                    "
                                                ></v-text-field
                                            ></v-col>

                                            <v-col cols="12">
                                                <v-textarea
                                                    :disabled="isLoading"
                                                    label="Complications"
                                                    outlined
                                                    auto-grow
                                                    v-model="
                                                        billingItem.arComplications
                                                    "
                                                ></v-textarea>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                            </v-col>

                            <v-col cols="12" v-show="!billingItem.arDischarged">
                                <v-textarea
                                    :disabled="isLoading"
                                    label="General notes"
                                    outlined
                                    auto-grow
                                    v-model="billingItem.arGeneralNotes"
                                ></v-textarea>
                            </v-col>

                            <v-col cols="12" v-show="!billingItem.arDischarged">
                                <h3>
                                    Files
                                    <v-btn
                                        :disabled="isLoading"
                                        @click="newAccountFileB"
                                        class="text-none ml-2"
                                        color="secondary darken-1"
                                        fab
                                        x-small
                                    >
                                        <v-icon>mdi-plus</v-icon>
                                    </v-btn>
                                </h3>
                                <v-card
                                    :key="billingItemFile.id"
                                    @click="
                                        loadAccountFileFormB(billingItemFile)
                                    "
                                    class="mt-5"
                                    no-gutters
                                    v-for="billingItemFile in billingItemFilesB"
                                >
                                    <v-card-text class="py-0">
                                        <v-row>
                                            <v-col cols="8">
                                                {{
                                                    accountFileTypes.find(
                                                        (x) =>
                                                            x.key ==
                                                            billingItemFile.accountFileType
                                                    )
                                                        ? accountFileTypes.find(
                                                              (x) =>
                                                                  x.key ==
                                                                  billingItemFile.accountFileType
                                                          ).value
                                                        : ""
                                                }}
                                            </v-col>

                                            <v-col
                                                align-self="center"
                                                class="text-center"
                                                cols="4"
                                            >
                                                <v-btn
                                                    @click.stop="
                                                        $store.dispatch(
                                                            'files/get',
                                                            {
                                                                fileId:
                                                                    billingItemFile.fileId,
                                                                namePrefix:
                                                                    billingItemFile.billingItemId.toString() +
                                                                    '_' +
                                                                    accountFileTypes
                                                                        .find(
                                                                            (
                                                                                x
                                                                            ) =>
                                                                                x.key ==
                                                                                billingItemFile.accountFileType
                                                                        )
                                                                        .value.split(
                                                                            ' '
                                                                        )
                                                                        .join(
                                                                            '_'
                                                                        ),
                                                            }
                                                        )
                                                    "
                                                    fab
                                                >
                                                    <h3>
                                                        <v-icon
                                                            color="light-blue"
                                                            >mdi-download</v-icon
                                                        >
                                                    </h3>
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                        <v-row
                            align="end"
                            class="pt-0"
                            justify="space-between"
                            no-gutters
                        >
                            <v-btn
                                @click="closeModalForm"
                                class="text-none"
                                color="warning darken-1"
                                text
                                v-show="isModal"
                                >Close</v-btn
                            >
                            <v-spacer></v-spacer>
                            <v-btn
                                v-show="canSave"
                                :disabled="isLoading"
                                :loading="isSaving"
                                @click="saveEntity"
                                class="text-none"
                                color="secondary darken-1"
                                text
                                >Save</v-btn
                            >
                        </v-row>
                    </v-container>
                </v-card-text>
            </v-form>
        </v-card>
        <v-dialog persistent v-model="accountFileFormVisibleA" width="500px">
            <BillingItemFileForm
                :billing-item-file-in="accountFileFormEntityA"
                :can-delete="true"
                :key="accountFileFormKeyA"
                @close="closeAccountFileFormA"
                @deleted="deletedAccountFileA"
                @saved="savedAccountFileA"
            />
        </v-dialog>

        <v-dialog persistent v-model="accountFileFormVisibleB" width="500px">
            <BillingItemFileForm
                :billing-item-file-in="accountFileFormEntityB"
                :can-delete="true"
                :key="accountFileFormKeyB"
                @close="closeAccountFileFormB"
                @deleted="deletedAccountFileB"
                @saved="savedAccountFileB"
            />
        </v-dialog>
    </v-container>
</template>

<script>
import BillingItem from "../../models/BillingItem.model";
import dateToString from "../../helpers/dateToString";
import BillingItemFile from "../../models/BillingItemFile.model";
import BillingItemFileForm from "../forms/BillingItemFileForm";
import AccountFileType from "../../constants/AccountFileType.constant";
export default {
    props: {
        billingItemIn: Object,
        isModal: Boolean,
        canSave: Boolean,
    },
    components: {
        BillingItemFileForm,
        //
    },
    created: async function() {
        //
        this.medediStatuses = await this.$store.dispatch(
            "billingitems/getMedediStatuses"
        );
        this.localBillingStatuses = await this.$store.dispatch(
            "billingitems/getLocalStatuses"
        );
        this.medediPlacesOfService = await this.$store.dispatch(
            "billingitems/getMedediPlacesOfService"
        );
        this.accountFileTypes = await this.$store.dispatch(
            "accounts/getFileTypes"
        );
    },
    mounted: async function() {
        //
        this.loadBillingItem();
        if (!this.canSave) this.isLoading = true;
    },
    data() {
        return {
            billingItemFilesA: [],
            billingItemFilesB: [],

            accountFileTypes: [],
            accountFileType: AccountFileType,

            accountFileFormKeyA: null,
            accountFileFormEntityA: null,
            accountFileFormVisibleA: false,

            accountFileFormKeyB: null,
            accountFileFormEntityB: null,
            accountFileFormVisibleB: false,

            billingItem: {},
            medediStatuses: [],
            localBillingStatuses: [],
            medediPlacesOfService: [],
            showDateSelectorA: false,
            isValid: null,
            isLoading: null,
            isSaving: null,
            isDeleting: null,
            requiredRule: (v) => !!v || "required",
            lengthRule: (limit) => (v) =>
                !v || v.length <= limit || "exceeds " + limit + " characters",
            emailRule: (v) => /.+@.+$/.test(v) || "invalid email",
            gettingLink: null,
            checkingInvoiceStatus: null,
            convertingToAccount: null,

            captureIABillingItemId: 0,
            isShowCaptureIA: false,
            captureARBillingItemId: 0,
            isShowCaptureAR: false,
            capturePRBillingItemId: 0,
            isShowCapturePR: false,
            referralLetter: null,
        };
    },
    computed: {
        //
    },
    methods: {
        savedAccountFileA(accountFileIn) {
            var updateIndex = this.billingItemFilesA.findIndex(
                (x) => x.id == accountFileIn.id
            );
            if (updateIndex > -1)
                this.$set(this.billingItemFilesA, updateIndex, accountFileIn);
            else this.billingItemFilesA.push(accountFileIn);
            //this.emitSavedEntity(this.billingItem);
        },
        deletedAccountFileA(accountFileIn) {
            var deletedIndex = this.billingItemFilesA.findIndex(
                (x) => x.id == accountFileIn.id
            );
            if (deletedIndex > -1)
                this.$delete(this.billingItemFilesA, deletedIndex);

            //this.emitDeletedEntity(accountFileIn);
        },
        newAccountFileA() {
            var billingItemFile = new BillingItemFile();
            billingItemFile.id = 0;
            billingItemFile.billingItemId = this.billingItem.id;
            billingItemFile.accountFileType = this.accountFileType.Communication;
            billingItemFile.validUntil = null;
            billingItemFile.isVerified = false;
            this.loadAccountFileFormA(billingItemFile);
        },
        loadAccountFileFormA(billingItemFile) {
            this.accountFileFormEntityA = billingItemFile;
            this.accountFileFormKeyA = billingItemFile.id;
            this.accountFileFormVisibleA = true;
        },
        closeAccountFileFormA() {
            this.accountFileFormKeyA = null;
            this.accountFileFormVisibleA = false;
        },

        savedAccountFileB(accountFileIn) {
            var updateIndex = this.billingItemFilesB.findIndex(
                (x) => x.id == accountFileIn.id
            );
            if (updateIndex > -1)
                this.$set(this.billingItemFilesB, updateIndex, accountFileIn);
            else this.billingItemFilesB.push(accountFileIn);
            //this.emitSavedEntity(this.billingItem);
        },
        deletedAccountFileB(accountFileIn) {
            var deletedIndex = this.billingItemFilesB.findIndex(
                (x) => x.id == accountFileIn.id
            );
            if (deletedIndex > -1)
                this.$delete(this.billingItemFilesB, deletedIndex);

            //this.emitDeletedEntity(accountFileIn);
        },
        newAccountFileB() {
            var billingItemFile = new BillingItemFile();
            billingItemFile.id = 0;
            billingItemFile.billingItemId = this.billingItem.id;
            billingItemFile.accountFileType = this.accountFileType.TransferCaseProfile;
            billingItemFile.validUntil = null;
            billingItemFile.isVerified = false;
            this.loadAccountFileFormB(billingItemFile);
        },
        loadAccountFileFormB(billingItemFile) {
            this.accountFileFormEntityB = billingItemFile;
            this.accountFileFormKeyB = billingItemFile.id;
            this.accountFileFormVisibleB = true;
        },
        closeAccountFileFormB() {
            this.accountFileFormKeyB = null;
            this.accountFileFormVisibleB = false;
        },

        dateToString(i) {
            return dateToString(i);
        },
        closeModalForm() {
            this.$emit("close");
        },
        reload() {
            this.$emit("reload");
        },
        getFile(fileId, namePrefix) {
            this.$store.dispatch("files/get", {
                fileId: fileId,
                namePrefix: namePrefix,
            });
        },
        getMedediStatusName(statusId) {
            var statuses = this.medediStatuses.filter(function(item) {
                return item.key == statusId;
            });
            if (statuses.length > 0) return "Submitted";
            //statuses[0].value;
            else return "Not Submitted"; //"N/A";
        },
        getMedediPlaceOfServiceName(statusId) {
            var statuses = this.medediPlacesOfService.filter(function(item) {
                return item.key == statusId;
            });
            if (statuses.length > 0) return statuses[0].value;
            else return "N/A";
        },

        loadBillingItem() {
            this.billingItem = new BillingItem().set(this.billingItemIn);

            this.billingItemFilesA = this.billingItem.billingItemFiles.filter(
                (x) =>
                    x.accountFileType == this.accountFileType.Communication
            );
            this.billingItemFilesB = this.billingItem.billingItemFiles.filter(
                (x) =>
                    x.accountFileType == this.accountFileType.TransferCaseProfile
            );
        },
        //emitters      ------------------------------------------------------------
        //general       ------------------------------------------------------------
        notify(message, color) {
            this.$emit("notify", message, color);
        },
        validateForm() {
            this.isValid = this.$refs.billingItemFormIA.validate();
            return this.isValid;
        },
        //save      ------------------------------------------------------------
        async saveEntity() {
            if (this.validateForm()) {
                this.isLoading = true;
                this.isSaving = true;
                var hasId = this.billingItem.id > 0;

                this.billingItem.arIsSaved = true;

                var formdata = new FormData();
                formdata.append("ReferralLetter", this.referralLetter);
                formdata.append("Model", JSON.stringify(this.billingItem));

                const parameters = {
                    id: this.billingItem.id,
                    formData: formdata,
                };

                try {
                    //var billingResponse =
                    await this.$store.dispatch(
                        "billingitems/" + (hasId ? "update" : "create"),
                        !hasId ? parameters.formData : parameters
                    );
                    this.notify("Billing item successfully saved.", "success");
                    this.reload();
                    if (!hasId) this.closeModalForm();
                } catch (e) {
                    this.notify(e.response.data, "error");
                }
                this.saveEntityDone();
            }
        },
        saveEntityDone() {
            this.isLoading = false;
            this.isSaving = false;
            this.isSendingWelcome = false;
        },
    },
};
</script>

<style lang="stylus" scoped></style>
